module.exports = __webpack_public_path__ + "images/emoji/headphones.268e9279b96030c843e3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/headphones.png
// module id = jWrp
// module chunks = 1